module.exports = __webpack_public_path__ + "media/metal_sheet_4.39ed2a86.webm";